import { mountRedditEvent } from './mountRedditEvent';
import { RedditEvent } from './types';

export function mountRedditPageVisit() {
  mountRedditEvent({
    name: RedditEvent.PageVisit,
  });
}
